import classNames from 'classnames';
import PropTypes from "prop-types";
// import Link from "next/link";
import ImgRight from "@/lib/assets/images/arrow-bg-b.svg";
import ImgLeft from "@/lib/assets/images/arrow-white-prev.svg";
import { getAdjacentUri } from "@/lib/utils/helpers";
// import * as constants from "@/lib/utils/constants";
// import dynamic from "next/dynamic";
import Link from "next/link";

export default function Pagination({ total, paged, hasMore, hasPrevious, uri, className }) {
  // const totalPages = Math.ceil(total / constants.POSTS_PER_PAGE);

  return (
    <div className={classNames(
      'flex justify-center items-center my-5 lg:my-10 gap-8 lg:gap-36',
      className
    )}>
      <div>
        <Link
          className={classNames(
            `mom-btn mom-btn--fill [&_svg]:mr-0 [&_svg]:size-2.5 [&_svg]:align-baseline`,
            {'opacity-30 pointer-events-none': !hasPrevious || paged <= 1}
          )}
          href={getAdjacentUri(uri, paged, -1)}
        >
          <ImgLeft /> Prev
        </Link>
      </div>

      {/*{totalPages > 1 && (
        <ul>
          {getPageNumbers(paged, totalPages).map((page, index) => (
            <li key={index}>
              {page === '...' ? (
                <>...</>
              ) : (
                <Link
                  href={`${getConcatenatedUrlParts(uri, page > 1 ? `/page/${page}` : '')}`}
                  className={classNames([{'active': paged === page}])}
                  prefetch={false}
                >
                  {page}
                </Link>
              )}
            </li>
          ))}
        </ul>
      )}*/}

      <div>
        {hasMore && (
          <Link
            className={classNames(
              `mom-btn mom-btn--fill [&_svg]:mr-0 [&_svg]:size-2.5 [&_svg]:align-baseline`,
              {'opacity-30 pointer-events-none': !hasMore}
            )}
            href={getAdjacentUri(uri, paged, 1)}
          >
            Next <ImgRight />
          </Link>)}
      </div>
    </div>
  );
}

Pagination.propTypes = {
  total: PropTypes.number.isRequired,
  paged: PropTypes.number.isRequired,
  className: PropTypes.string,
  uri: PropTypes.string,
  hasMore: PropTypes.bool.isRequired,
  hasPrevious: PropTypes.bool.isRequired,
};
